import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Colors from '../../Constant/Colors';

export const TextLink = styled(Link)`
  color: ${Colors.primary};
  text-decoration: none;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
  &:hover{
    cursor: pointer;
  }
`;
